import {
  Plant,
  Leaf,
  Cloud,
  Drop,
  Truck,
  ChartLineUp,
} from "@phosphor-icons/react";
import { subdomainImage } from "./utils";

const slug = "agriculture";

/** Agriculture — agriculture.bizlem.com */
const agricultureConfig = {
  slug,
  name: "Agriculture",
  shortName: "Agriculture",
  host: "agriculture.bizlem.com",
  icon: Plant,
  theme: {
    primary: "bg-emerald-600",
    primaryHover: "hover:bg-emerald-700",
    primaryText: "text-emerald-600",
    primaryBorder: "border-emerald-600",
    tint: "bg-emerald-50",
    heroGradient: "from-emerald-800 via-emerald-600 to-emerald-500",
    cream: "bg-emerald-50/40",
    badge: "bg-emerald-50 border-emerald-200 text-emerald-700",
    ring: "ring-emerald-100",
  },
  hero: {
    badge: "AI-Powered Agri Intelligence",
    headline: ["Precision Farming.", "Sustainable Yields.", "Smarter Harvests."],
    highlightLine: 1,
    description:
      "Crop intelligence, weather analytics, and sustainable agri-solutions for large-scale farms, cooperatives, and agribusiness enterprises.",
    image: "https://images.pexels.com/photos/34182412/pexels-photo-34182412.jpeg?auto=compress&cs=tinysrgb&w=1600",
    ctaPrimary: "Request Demo",
    ctaSecondary: "Explore Solutions",
  },
  about: {
    label: "WHAT WE DO",
    heading: "Enabling agribusiness with intelligent, sustainable ecosystems",
    body: "From field to market, our platform connects crop monitoring, supply chain, weather intelligence, and sustainability reporting into one AI-powered agricultural system.",
  },
  modules: {
    label: "MODULES",
    heading: "Integrated Modules. One Intelligent Farm.",
    body: "Every module is purpose-built for agriculture and works in sync — so crop health, irrigation, logistics, and sustainability all run on a single connected platform.",
    items: [
      { icon: Plant, title: "Precision Farming", body: "Satellite and sensor-based field monitoring with variable-rate application recommendations.", iconBg: "bg-emerald-100 text-emerald-700" },
      { icon: Leaf, title: "Crop Intelligence", body: "AI models for disease detection, growth stage tracking, and harvest timing optimization.", iconBg: "bg-lime-100 text-lime-700" },
      { icon: Cloud, title: "Weather Analytics", body: "Hyperlocal weather forecasting and climate risk assessment for planting and harvest decisions.", iconBg: "bg-sky-100 text-sky-700" },
      { icon: Drop, title: "Irrigation Optimization", body: "Smart water management with soil moisture monitoring and automated irrigation scheduling.", iconBg: "bg-blue-100 text-blue-700" },
      { icon: Truck, title: "Supply Chain Intelligence", body: "Farm-to-market logistics optimization, cold chain monitoring, and inventory forecasting.", iconBg: "bg-amber-100 text-amber-700" },
      { icon: ChartLineUp, title: "Yield Forecasting", body: "Predictive yield models combining historical data, weather, and field conditions.", iconBg: "bg-orange-100 text-orange-700" },
    ],
  },
  solutions: {
    label: "SOLUTIONS",
    heading: "Built for every scale of agriculture",
    items: [
      {
        title: "Large-Scale Farms",
        points: ["Multi-field crop monitoring", "Fleet & equipment tracking", "Labor optimization", "Harvest planning intelligence"],
        image: "https://images.pexels.com/photos/34182412/pexels-photo-34182412.jpeg?auto=compress&cs=tinysrgb&w=800",
      },
      {
        title: "Cooperatives",
        points: ["Member farm aggregation", "Collective procurement intelligence", "Quality grading automation", "Market price analytics"],
        image: subdomainImage(slug, "cooperatives.png"),
      },
      {
        title: "Agri-Processing",
        points: ["Processing plant optimization", "Quality control automation", "Traceability & compliance", "Waste reduction analytics"],
        image: "https://images.unsplash.com/photo-1625246333195-78d9c38ad449?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
      },
      {
        title: "Sustainability & ESG",
        points: ["Carbon footprint tracking", "Water usage reporting", "Regenerative agriculture metrics", "ESG compliance dashboards"],
        image: subdomainImage(slug, "sustainability-esg.png"),
      },
    ],
  },
  whyChoose: {
    label: "WHY CHOOSE US",
    heading: "Built for Scale. Designed for Simplicity.",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    items: [
      "One unified platform for all agricultural operations",
      "Scalable from smallholder networks to enterprise farms",
      "AI models trained on diverse crop and climate data",
      "Sustainability and ESG reporting built in",
    ],
  },
  footerTagline:
    "AI-Powered Agricultural Intelligence — connecting fields, supply chains, and sustainability into one intelligent ecosystem.",
  contactIndustry: "Agriculture",
};

export default agricultureConfig;
